import { render } from "./AskPaperView.vue?vue&type=template&id=419d7964&scoped=true"
import script from "./AskPaperView.vue?vue&type=script&lang=js"
export * from "./AskPaperView.vue?vue&type=script&lang=js"

import "./AskPaperView.vue?vue&type=style&index=0&id=419d7964&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419d7964"]])

export default __exports__